/* eslint-disable */

import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Accordion from "react-bootstrap/Accordion";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import {
  FiCheckCircle,
  FiUser,
  FiUsers,
  FiCpu,
  FiArrowRight,
  FiZap,
  FiHelpCircle,
  FiDollarSign,
} from "react-icons/fi";
import AppNavbar from "../components/Navbar.js";
import AppFooter from "../components/Footer.js";

export default function Pricing() {
  // Calculator state
  const [calcType, setCalcType] = useState("individual"); // "individual" | "group" | "moji"
  const [sponsorshipAmount, setSponsorshipAmount] = useState(50000);
  const [groupAmount, setGroupAmount] = useState(250000);
  const [mojiUsers, setMojiUsers] = useState(50);

  // Fee computations
  // 1. Individual: 1000 Naira flat fee + ~1.5% transaction cost
  const indFlatFee = 1000;
  const indTxFee = Math.round(sponsorshipAmount * 0.015);
  const indTotal = Number(sponsorshipAmount) + indFlatFee + indTxFee;

  // 2. Group: 15% of total spend + ~1.5% transaction cost
  const groupFee = Math.round(groupAmount * 0.15);
  const groupTxFee = Math.round(groupAmount * 0.015);
  const groupTotal = Number(groupAmount) + groupFee + groupTxFee;

  // 3. Moji for Providers: Flat fee per user per cohort (e.g., ₦21,000 / user / cohort sample)
  const mojiRatePerUser = 21000;
  const mojiTotal = mojiUsers * mojiRatePerUser;

  return (
    <div style={{ backgroundColor: "#F8FAFC", minHeight: "100vh", fontFamily: "'Manrope', 'Inter', sans-serif" }}>
      {/* Header Navigation */}
      <AppNavbar />

      <main style={{ paddingTop: "96px", paddingBottom: "80px" }}>
        {/* ── Hero Section ──────────────────────────────────────────────────────── */}
        <section className="text-center py-5 position-relative overflow-hidden">
          <Container className="py-4">

            <h1
              className="fw-bold mb-3 mx-auto"
              style={{
                fontSize: "clamp(2.2rem, 4vw, 3.4rem)",
                color: "#0F172A",
                maxWidth: "850px",
                lineHeight: 1.2,
                letterSpacing: "-0.5px",
              }}
            >
              Simple, Honest Fees for Empowering Learners
            </h1>

            <p
              className="mx-auto mb-5"
              style={{
                color: "#334155",
                fontSize: "clamp(1rem, 1.8vw, 1.2rem)",
                maxWidth: "680px",
                lineHeight: 1.6,
                fontWeight: 500,
              }}
            >
              No hidden margins or surprise deductions.
            </p>
          </Container>
        </section>

        {/* ── Pricing Tiers Grid ────────────────────────────────────────────────── */}
        <section className="pb-5">
          <Container>
            <Row className="g-4 align-items-stretch justify-content-center">
              {/* Tier 1: Individual Sponsorship */}
              <Col lg={4} md={6}>
                <Card
                  className="h-100 border-0 shadow-sm rounded-4 p-4 position-relative d-flex flex-column"
                  style={{
                    backgroundColor: "#FFFFFF",
                    transition: "transform 0.25s ease, box-shadow 0.25s ease",
                    border: "1px solid #CBD5E1",
                  }}
                >
                  <div className="mb-4">
                    <div
                      className="d-inline-flex align-items-center justify-content-center mb-3 rounded-3"
                      style={{
                        width: "48px",
                        height: "48px",
                        backgroundColor: "#E6F7F3",
                        color: "#00886C",
                      }}
                    >
                      <FiUser size={24} />
                    </div>
                    <h3 className="fw-bold mb-1" style={{ fontSize: "1.35rem", color: "#0F172A" }}>
                      Individual Sponsorship
                    </h3>
                    <p style={{ fontSize: "0.925rem", minHeight: "40px", color: "#475569", fontWeight: 500 }}>
                      Sponsor a single learner directly for any verified digital skill or course.
                    </p>
                  </div>

                  <div className="mb-4 p-3 rounded-3" style={{ backgroundColor: "#F8FAFC", border: "1px solid #E2E8F0" }}>
                    <div className="d-flex align-items-baseline gap-1">
                      <span className="fw-bold" style={{ fontSize: "2rem", color: "#0F172A" }}>
                        ₦1,000
                      </span>
                      <span className="fw-bold" style={{ fontSize: "0.9rem", color: "#334155" }}>
                        flat fee / sponsorship
                      </span>
                    </div>
                    <div className="mt-2" style={{ fontSize: "0.85rem", color: "#475569", fontWeight: 500 }}>
                      + Standard transaction costs covered by user at checkout
                    </div>
                  </div>

                  <ul className="list-unstyled d-flex flex-column gap-3 mb-4 flex-grow-1" style={{ fontSize: "0.925rem" }}>
                    <li className="d-flex align-items-start gap-2">
                      <FiCheckCircle size={18} color="#00886C" className="mt-1 flex-shrink-0" />
                      <span style={{ color: "#0F172A", fontWeight: 600 }}>100% course funding delivered directly to provider</span>
                    </li>
                    <li className="d-flex align-items-start gap-2">
                      <FiCheckCircle size={18} color="#00886C" className="mt-1 flex-shrink-0" />
                      <span style={{ color: "#0F172A", fontWeight: 600 }}>Verified milestone progress & completion tracking</span>
                    </li>
                    <li className="d-flex align-items-start gap-2">
                      <FiCheckCircle size={18} color="#00886C" className="mt-1 flex-shrink-0" />
                      <span style={{ color: "#0F172A", fontWeight: 600 }}>Direct 1-on-1 meetup or anonymous funding options</span>
                    </li>
                    <li className="d-flex align-items-start gap-2">
                      <FiCheckCircle size={18} color="#00886C" className="mt-1 flex-shrink-0" />
                      <span style={{ color: "#0F172A", fontWeight: 600 }}>Automated email & receipt updates</span>
                    </li>
                  </ul>

                  <Link to="/help-learner" className="text-decoration-none mt-auto">
                    <Button
                      className="w-100 btn-primary d-flex align-items-center justify-content-center gap-2"
                      style={{ minHeight: "48px", borderRadius: "999px", fontWeight: 700 }}
                    >
                      Sponsor a Learner <FiArrowRight size={18} />
                    </Button>
                  </Link>
                </Card>
              </Col>

              {/* Tier 2: Group Sponsorship (Featured) */}
              <Col lg={4} md={6}>
                <Card
                  className="h-100 border-0 shadow-lg rounded-4 p-4 position-relative d-flex flex-column"
                  style={{
                    backgroundColor: "#FFFFFF",
                    border: "2px solid #00AA87",
                  }}
                >
                  {/* Badge */}
                  <div
                    className="position-absolute top-0 start-50 translate-middle px-3 py-1 rounded-pill text-white fw-bold text-nowrap"
                    style={{
                      backgroundColor: "#00AA87",
                      fontSize: "0.75rem",
                      letterSpacing: "0.8px",
                      textTransform: "uppercase",
                      whiteSpace: "nowrap",
                    }}
                  >
                    FOR COMPANIES & FOUNDATIONS
                  </div>

                  <div className="mb-4 mt-2">
                    <div
                      className="d-inline-flex align-items-center justify-content-center mb-3 rounded-3"
                      style={{
                        width: "48px",
                        height: "48px",
                        backgroundColor: "rgba(255, 122, 89, 0.12)",
                        color: "#FF7A59",
                      }}
                    >
                      <FiUsers size={24} />
                    </div>
                    <h3 className="fw-bold mb-1" style={{ fontSize: "1.35rem", color: "#0F172A" }}>
                      Group Sponsorship
                    </h3>
                    <p style={{ fontSize: "0.925rem", minHeight: "40px", color: "#475569", fontWeight: 500 }}>
                      For foundations, companies, & individuals sponsoring cohorts or groups of learners.
                    </p>
                  </div>

                  <div className="mb-4 p-3 rounded-3" style={{ backgroundColor: "#E6F7F3", border: "1px solid rgba(0, 170, 135, 0.3)" }}>
                    <div className="d-flex align-items-baseline gap-1">
                      <span className="fw-bold" style={{ fontSize: "2rem", color: "#00886C" }}>
                        15%
                      </span>
                      <span className="fw-bold" style={{ fontSize: "0.9rem", color: "#00886C" }}>
                        of total spend
                      </span>
                    </div>
                    <div className="mt-2" style={{ fontSize: "0.85rem", color: "#006651", fontWeight: 600 }}>
                      + Standard transaction fees passed transparently to checkout
                    </div>
                  </div>

                  <ul className="list-unstyled d-flex flex-column gap-3 mb-4 flex-grow-1" style={{ fontSize: "0.925rem" }}>
                    <li className="d-flex align-items-start gap-2">
                      <FiCheckCircle size={18} color="#00886C" className="mt-1 flex-shrink-0" />
                      <span style={{ color: "#0F172A", fontWeight: 600 }}>Dedicated group matching & cohort selection</span>
                    </li>
                    <li className="d-flex align-items-start gap-2">
                      <FiCheckCircle size={18} color="#00886C" className="mt-1 flex-shrink-0" />
                      <span style={{ color: "#0F172A", fontWeight: 600 }}>Aggregated cohort analytics & impact reports</span>
                    </li>
                    <li className="d-flex align-items-start gap-2">
                      <FiCheckCircle size={18} color="#00886C" className="mt-1 flex-shrink-0" />
                      <span style={{ color: "#0F172A", fontWeight: 600 }}>Custom brand acknowledgement on learner portal</span>
                    </li>
                    <li className="d-flex align-items-start gap-2">
                      <FiCheckCircle size={18} color="#00886C" className="mt-1 flex-shrink-0" />
                      <span style={{ color: "#0F172A", fontWeight: 600 }}>Accountability manager & concierge support</span>
                    </li>
                  </ul>

                  <Link to="/help-learner" className="text-decoration-none mt-auto">
                    <Button
                      className="w-100 btn-primary d-flex align-items-center justify-content-center gap-2"
                      style={{ minHeight: "48px", borderRadius: "999px", fontWeight: 700 }}
                    >
                      Sponsor a Group <FiArrowRight size={18} />
                    </Button>
                  </Link>
                </Card>
              </Col>

              {/* Tier 3: Moji AI for Course Providers */}
              <Col lg={4} md={6}>
                <Card
                  className="h-100 border-0 shadow-sm rounded-4 p-4 position-relative d-flex flex-column"
                  style={{
                    backgroundColor: "#FFFFFF",
                    transition: "transform 0.25s ease, box-shadow 0.25s ease",
                    border: "1px solid #CBD5E1",
                  }}
                >
                  <div className="mb-4">
                    <div
                      className="d-inline-flex align-items-center justify-content-center mb-3 rounded-3"
                      style={{
                        width: "48px",
                        height: "48px",
                        backgroundColor: "#EEF2FF",
                        color: "#4F46B5",
                      }}
                    >
                      <FiCpu size={24} />
                    </div>
                    <h3 className="fw-bold mb-1" style={{ fontSize: "1.35rem", color: "#0F172A" }}>
                      Moji AI for Providers
                    </h3>
                    <p style={{ fontSize: "0.925rem", minHeight: "40px", color: "#475569", fontWeight: 500 }}>
                      For bootcamps & course providers deploying Moji AI coaching across cohorts.
                    </p>
                  </div>

                  <div className="mb-4 p-3 rounded-3" style={{ backgroundColor: "#EEF2FF", border: "1px solid #C7D2FE" }}>
                    <div className="d-flex align-items-baseline gap-1">
                      <span className="fw-bold" style={{ fontSize: "1.8rem", color: "#4F46B5" }}>
                        Flat Fee
                      </span>
                      <span className="fw-bold" style={{ fontSize: "0.85rem", color: "#3730A3" }}>
                        / user / cohort
                      </span>
                    </div>
                    <div className="mt-2" style={{ fontSize: "0.85rem", color: "#3730A3", fontWeight: 600 }}>
                      Custom volume tiers available for large platforms
                    </div>
                  </div>

                  <ul className="list-unstyled d-flex flex-column gap-3 mb-4 flex-grow-1" style={{ fontSize: "0.925rem" }}>
                    <li className="d-flex align-items-start gap-2">
                      <FiCheckCircle size={18} color="#4F46B5" className="mt-1 flex-shrink-0" />
                      <span style={{ color: "#0F172A", fontWeight: 600 }}>24/7 Contextual AI accountability support & tutoring</span>
                    </li>
                    <li className="d-flex align-items-start gap-2">
                      <FiCheckCircle size={18} color="#4F46B5" className="mt-1 flex-shrink-0" />
                      <span style={{ color: "#0F172A", fontWeight: 600 }}>Proactive drop-out prevention & check-ins</span>
                    </li>
                    <li className="d-flex align-items-start gap-2">
                      <FiCheckCircle size={18} color="#4F46B5" className="mt-1 flex-shrink-0" />
                      <span style={{ color: "#0F172A", fontWeight: 600 }}>Custom syllabus & documentation ingestion</span>
                    </li>
                    <li className="d-flex align-items-start gap-2">
                      <FiCheckCircle size={18} color="#4F46B5" className="mt-1 flex-shrink-0" />
                      <span style={{ color: "#0F172A", fontWeight: 600 }}>Provider admin analytics & intervention logs</span>
                    </li>
                  </ul>

                  <a href="mailto:contact@motivar.live?subject=Moji%20Provider%20Integration" className="text-decoration-none mt-auto">
                    <Button
                      className="w-100 d-flex align-items-center justify-content-center gap-2"
                      style={{
                        minHeight: "48px",
                        borderRadius: "999px",
                        fontWeight: 700,
                        backgroundColor: "#4F46B5",
                        borderColor: "#4F46B5",
                        color: "#FFFFFF",
                      }}
                    >
                      Partner with Moji <FiArrowRight size={18} />
                    </Button>
                  </a>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>

        {/* ── Interactive Fee Estimator Widget ──────────────────────────────────── */}
        <section className="py-5" style={{ backgroundColor: "#FFFFFF", borderTop: "1px solid #E2E8F0", borderBottom: "1px solid #E2E8F0" }}>
          <Container>
            <div className="text-center mb-5">
              <div
                className="d-inline-flex align-items-center gap-2 px-3 py-1 mb-2 rounded-pill"
                style={{ backgroundColor: "#F1F5F9", color: "#334155", fontSize: "0.85rem", fontWeight: 700 }}
              >
                <FiDollarSign size={16} /> INTERACTIVE CALCULATOR
              </div>
              <h2 className="fw-bold" style={{ fontSize: "2rem", color: "#0F172A" }}>
                Estimate Your Total Sponsorship Cost
              </h2>
              <p className="mx-auto" style={{ maxWidth: "580px", color: "#334155", fontWeight: 500 }}>
                Calculate exact breakdown before funding individual learners, groups, or deploying Moji.
              </p>
            </div>

            <Row className="justify-content-center">
              <Col lg={8}>
                <Card className="border-0 shadow-sm rounded-4 p-4" style={{ backgroundColor: "#F8FAFC", border: "1px solid #CBD5E1" }}>
                  {/* Selector Tabs */}
                  <div className="d-flex justify-content-center gap-2 mb-4 p-1 rounded-pill bg-white border" style={{ maxWidth: "460px", margin: "0 auto", borderColor: "#CBD5E1" }}>
                    <Button
                      variant="none"
                      className="flex-fill rounded-pill py-2 fw-bold text-nowrap"
                      style={{
                        backgroundColor: calcType === "individual" ? "#00AA87" : "transparent",
                        color: calcType === "individual" ? "#FFFFFF" : "#334155",
                        fontSize: "0.875rem",
                      }}
                      onClick={() => setCalcType("individual")}
                    >
                      Individual (₦1,000)
                    </Button>
                    <Button
                      variant="none"
                      className="flex-fill rounded-pill py-2 fw-bold text-nowrap"
                      style={{
                        backgroundColor: calcType === "group" ? "#00AA87" : "transparent",
                        color: calcType === "group" ? "#FFFFFF" : "#334155",
                        fontSize: "0.875rem",
                      }}
                      onClick={() => setCalcType("group")}
                    >
                      Group (15%)
                    </Button>
                    <Button
                      variant="none"
                      className="flex-fill rounded-pill py-2 fw-bold text-nowrap"
                      style={{
                        backgroundColor: calcType === "moji" ? "#4F46B5" : "transparent",
                        color: calcType === "moji" ? "#FFFFFF" : "#334155",
                        fontSize: "0.875rem",
                      }}
                      onClick={() => setCalcType("moji")}
                    >
                      Moji AI
                    </Button>
                  </div>

                  {/* Calculator Content: Individual */}
                  {calcType === "individual" && (
                    <div>
                      <Form.Group className="mb-4">
                        <Form.Label className="fw-semibold d-flex justify-content-between" style={{ color: "#0F172A" }}>
                          <span>Sponsorship Amount:</span>
                          <span className="fw-bold" style={{ color: "#00886C" }}>₦{Number(sponsorshipAmount).toLocaleString()}</span>
                        </Form.Label>
                        <Form.Range
                          min={10000}
                          max={500000}
                          step={5000}
                          value={sponsorshipAmount}
                          onChange={(e) => setSponsorshipAmount(Number(e.target.value))}
                        />
                      </Form.Group>

                      <div className="p-3 bg-white rounded-3 border" style={{ borderColor: "#E2E8F0" }}>
                        <div className="d-flex justify-content-between py-2 border-bottom" style={{ fontSize: "0.95rem", color: "#334155" }}>
                          <span>Course Direct Funding</span>
                          <span className="fw-bold" style={{ color: "#0F172A" }}>₦{Number(sponsorshipAmount).toLocaleString()}</span>
                        </div>
                        <div className="d-flex justify-content-between py-2 border-bottom" style={{ fontSize: "0.95rem", color: "#334155" }}>
                          <span>Motivar Flat Infrastructure Fee</span>
                          <span className="fw-bold" style={{ color: "#0F172A" }}>₦{indFlatFee.toLocaleString()}</span>
                        </div>
                        <div className="d-flex justify-content-between py-2 border-bottom" style={{ fontSize: "0.95rem", color: "#334155" }}>
                          <span>Est. Payment Gateway Cost (~1.5%)</span>
                          <span className="fw-bold" style={{ color: "#0F172A" }}>₦{indTxFee.toLocaleString()}</span>
                        </div>
                        <div className="d-flex justify-content-between pt-3 fw-bold" style={{ fontSize: "1.15rem", color: "#0F172A" }}>
                          <span>Total Payment:</span>
                          <span style={{ color: "#00886C" }}>₦{indTotal.toLocaleString()}</span>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Calculator Content: Group */}
                  {calcType === "group" && (
                    <div>
                      <Form.Group className="mb-4">
                        <Form.Label className="fw-semibold d-flex justify-content-between" style={{ color: "#0F172A" }}>
                          <span>Total Cohort Spend:</span>
                          <span className="fw-bold" style={{ color: "#00886C" }}>₦{Number(groupAmount).toLocaleString()}</span>
                        </Form.Label>
                        <Form.Range
                          min={100000}
                          max={5000000}
                          step={50000}
                          value={groupAmount}
                          onChange={(e) => setGroupAmount(Number(e.target.value))}
                        />
                      </Form.Group>

                      <div className="p-3 bg-white rounded-3 border" style={{ borderColor: "#E2E8F0" }}>
                        <div className="d-flex justify-content-between py-2 border-bottom" style={{ fontSize: "0.95rem", color: "#334155" }}>
                          <span>Group Course Pool</span>
                          <span className="fw-bold" style={{ color: "#0F172A" }}>₦{Number(groupAmount).toLocaleString()}</span>
                        </div>
                        <div className="d-flex justify-content-between py-2 border-bottom" style={{ fontSize: "0.95rem", color: "#334155" }}>
                          <span>Motivar Group Fee (15%)</span>
                          <span className="fw-bold" style={{ color: "#0F172A" }}>₦{groupFee.toLocaleString()}</span>
                        </div>
                        <div className="d-flex justify-content-between py-2 border-bottom" style={{ fontSize: "0.95rem", color: "#334155" }}>
                          <span>Est. Payment Gateway Cost (~1.5%)</span>
                          <span className="fw-bold" style={{ color: "#0F172A" }}>₦{groupTxFee.toLocaleString()}</span>
                        </div>
                        <div className="d-flex justify-content-between pt-3 fw-bold" style={{ fontSize: "1.15rem", color: "#0F172A" }}>
                          <span>Total Payment:</span>
                          <span style={{ color: "#00886C" }}>₦{groupTotal.toLocaleString()}</span>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Calculator Content: Moji */}
                  {calcType === "moji" && (
                    <div>
                      <Form.Group className="mb-4">
                        <Form.Label className="fw-semibold d-flex justify-content-between" style={{ color: "#0F172A" }}>
                          <span>Number of Learners in Cohort:</span>
                          <span className="fw-bold" style={{ color: "#4F46B5" }}>{mojiUsers} Users</span>
                        </Form.Label>
                        <Form.Range
                          min={10}
                          max={500}
                          step={10}
                          value={mojiUsers}
                          onChange={(e) => setMojiUsers(Number(e.target.value))}
                        />
                      </Form.Group>

                      <div className="p-3 bg-white rounded-3 border" style={{ borderColor: "#E2E8F0" }}>
                        <div className="d-flex justify-content-between py-2 border-bottom" style={{ fontSize: "0.95rem", color: "#334155" }}>
                          <span>Flat Rate per User per Cohort <span className="text-muted fw-normal" style={{ fontSize: "0.8rem" }}>(Sample)</span></span>
                          <span className="fw-bold" style={{ color: "#0F172A" }}>₦{mojiRatePerUser.toLocaleString()}</span>
                        </div>
                        <div className="d-flex justify-content-between py-2 border-bottom" style={{ fontSize: "0.95rem", color: "#334155" }}>
                          <span>Active Learners</span>
                          <span className="fw-bold" style={{ color: "#0F172A" }}>{mojiUsers}</span>
                        </div>
                        <div className="d-flex justify-content-between pt-3 fw-bold" style={{ fontSize: "1.15rem", color: "#0F172A" }}>
                          <span>Estimated Cohort Moji License:</span>
                          <span style={{ color: "#4F46B5" }}>₦{mojiTotal.toLocaleString()}</span>
                        </div>
                      </div>
                    </div>
                  )}
                </Card>
              </Col>
            </Row>
          </Container>
        </section>

        {/* ── FAQ Accordion Section ────────────────────────────────────────────── */}
        <section className="py-5">
          <Container style={{ maxWidth: "800px" }}>
            <div className="text-center mb-5">
              <div
                className="d-inline-flex align-items-center gap-2 px-3 py-1 mb-2 rounded-pill"
                style={{ backgroundColor: "rgba(0, 170, 135, 0.12)", color: "#00886C", fontSize: "0.85rem", fontWeight: 700 }}
              >
                <FiHelpCircle size={16} /> FREQUENTLY ASKED QUESTIONS
              </div>
              <h2 className="fw-bold" style={{ fontSize: "2rem", color: "#0F172A" }}>
                Got Questions About Our Fees?
              </h2>
            </div>

            <Accordion defaultActiveKey="0" className="custom-pricing-accordion">
              <Accordion.Item eventKey="0" className="border-0 shadow-xs mb-3 rounded-3 overflow-hidden">
                <Accordion.Header className="fw-bold">
                  How does the ₦1,000 flat fee work for individual sponsorships?
                </Accordion.Header>
                <Accordion.Body style={{ color: "#334155", fontSize: "0.95rem", lineHeight: 1.6, fontWeight: 500 }}>
                  When you sponsor a learner individually, Motivar adds a flat ₦1,000 fee to cover identity verification, course enrolment confirmation, milestone monitoring, and receipt distribution. 100% of the course cost goes directly to the education provider.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1" className="border-0 shadow-xs mb-3 rounded-3 overflow-hidden">
                <Accordion.Header className="fw-bold">
                  Why is there a 15% fee for group sponsorships?
                </Accordion.Header>
                <Accordion.Body style={{ color: "#334155", fontSize: "0.95rem", lineHeight: 1.6, fontWeight: 500 }}>
                  Group sponsorships require dedicated cohort management, custom branding, aggregated impact analytics, and dedicated support to ensure high completion rates across all learners. The 15% fee enables us to manage group logistics effectively.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2" className="border-0 shadow-xs mb-3 rounded-3 overflow-hidden">
                <Accordion.Header className="fw-bold">
                  What are transaction costs?
                </Accordion.Header>
                <Accordion.Body style={{ color: "#334155", fontSize: "0.95rem", lineHeight: 1.6, fontWeight: 500 }}>
                  Transaction costs are standard processing fees charged by card networks and payment processors (e.g. Paystack / Flutterwave). These costs are calculated transparently at checkout so there are no unexpected deductions.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3" className="border-0 shadow-xs mb-3 rounded-3 overflow-hidden">
                <Accordion.Header className="fw-bold">
                  How can course providers integrate Moji AI coaching?
                </Accordion.Header>
                <Accordion.Body style={{ color: "#334155", fontSize: "0.95rem", lineHeight: 1.6, fontWeight: 500 }}>
                  Course providers pay a flat fee per user per cohort. We ingest your curriculum, documentation, and assignments into Moji to provide 24/7 personalized support & coaching to your learners. Reach out to <a href="mailto:contact@motivar.live" className="fw-semibold" style={{ color: "#00AA87" }}>contact@motivar.live</a> to set up a cohort demo.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Container>
        </section>

        {/* ── Call To Action Banner ────────────────────────────────────────────── */}
        <section className="pt-4">
          <Container>
            <div
              className="p-5 rounded-4 text-center position-relative overflow-hidden"
              style={{
                background: "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
                color: "#FFFFFF",
              }}
            >
              <h2 className="fw-bold mb-3" style={{ fontSize: "2.2rem", color: "#FFFFFF" }}>
                Ready to Fuel the Future of Education?
              </h2>
              <p className="text-light mx-auto mb-4" style={{ maxWidth: "600px", opacity: 0.9, fontWeight: 500 }}>
                Whether you're an individual sponsor, an organization, or a bootcamp, Motivar provides the infrastructure for learner success.
              </p>
              <div className="d-flex flex-wrap justify-content-center gap-3">
                <Link to="/help-learner" className="text-decoration-none">
                  <Button className="btn-primary px-4 py-3 rounded-pill fw-bold">
                    Start Sponsoring Today
                  </Button>
                </Link>
                <a href="mailto:contact@motivar.live" className="text-decoration-none">
                  <Button variant="outline-light" className="px-4 py-3 rounded-pill fw-bold" style={{ borderWidth: "2px" }}>
                    Contact Sales & Support
                  </Button>
                </a>
              </div>
            </div>
          </Container>
        </section>
      </main>

      {/* Footer */}
      <AppFooter />
    </div>
  );
}
